<div class="d-flex align-items-center">
  @if (avatar) {
    <afra-image imgClass="teacher-img" [fileId]="avatar" alt=""></afra-image>
  } @else {
    <ng-icon
      name="lucideUserCircle"
      class="teacher-img me-2 text-secondary"
    ></ng-icon>
  }

  <div class="ms-3">
    <div>
      @if (linkName) {
        <a [routerLink]="['/teachers', teacherId]">{{ name }}</a>
      } @else {
        {{ name }}
      }
    </div>
    @if (position) {
      <div>{{ position }}</div>
    }
    @if (workshopsCount !== undefined) {
      <div class="text-muted">
        <i class="fa fa-cubes-stacked"></i>
        &nbsp;
        <span>{{ workshopsCount }}</span>
        کارگاه
      </div>
    }
  </div>
</div>
@if (bio) {
  <div class="mt-3 text-justify preserve-lines">{{ bio }}</div>
}
